<p class="mb-4">{{ description() }}</p>
<div class="flex justify-end gap-4 px-4">
  <p-button
    styleClass="customInfoButton outlined"
    label="Anuluj"
    (click)="dynamicDialogRef.close()"
  ></p-button>
  <p-button
    styleClass="customDangerButton"
    [label]="confirmButtonLabel()"
    (click)="dynamicDialogRef.close(true)"
  ></p-button>
</div>
